<template>
  <GoogleMapLoader
    :map-config="mapConfig"
    api-key="AIzaSyCu8wi_ObsAmDZsoBsgoUQEMCI87b06NIU"
    :get-position="getPosition"
  >
    <template slot-scope="{ google, map }">
      <GoogleMapMarker
        v-for="marker in markers"
        :key="marker.id"
        :marker="marker"
        :google="google"
        :map="map"
        :info-window="infoWindow"
        :info-window-instance="infoWindowInstance"
      />
      <GoogleMapLine
        v-for="line in lines"
        :key="line.id"
        :path.sync="line.path"
        :google="google"
        :map="map"
      />
    </template>
  </GoogleMapLoader>
</template>

<script>
import Vue from 'vue';
import { mapSettings } from '../../../js/constants';
import GoogleMapLoader from '../loadMap/index.vue';
import GoogleMapMarker from '../markers/index.vue';
import GoogleMapLine from '../line/index.vue';
import InfoWindowTemplate from '../markers/infoWindowTemplate/index.vue';

export default {
  name: 'TravelMap',
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
    GoogleMapLine,
  },
  props: {
    getPosition: {
      type: Boolean,
      default: false,
    },
    locations: {
      type: Array,
      default: () => [],
    },
    paths: {
      type: Array,
      default: () => [],
    },
    moreInfoButton: {
      type: Boolean,
      default: false,
    },
    infoWindowTemplateReport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      infoWindow: {},
      markers: [
        {
          id: 'a',
          position: { lat: null, lng: null },
        },
      ],
      lines: [
        {
          id: '-1',
          path: [{ lat: 40.4167, lng: -3.70325 }, { lat: 40.4167, lng: -3.70325 }],
        },
      ],
    };
  },
  computed: {
    mapConfig() {
      return {
        ...mapSettings,
        center: this.mapCenter,
      };
    },
    infoWindowInstance() {
      const InfoWindowClass = Vue.extend(InfoWindowTemplate);
      const infoWindowInstance = new InfoWindowClass({
        propsData: {
          moreInfoButton: this.moreInfoButton,
          infoWindowTemplateReport: this.infoWindowTemplateReport,
        },
        i18n: this.$i18n,
        store: this.$store,
      });
      infoWindowInstance.$mount();
      return infoWindowInstance;
    },
    mapCenter() {
      if (this.markers.length > 1) {
        return this.markers[1].position;
      } return { lat: 40.4167, lng: -3.70325 };
    },
  },
  beforeMount() {
    this.markers = [...this.markers, ...this.locations];
    this.lines = [...this.lines, ...this.paths];
  },
  mounted() {
    this.$root.$on('googleReady', (google) => {
      this.infoWindow = new google.maps.InfoWindow();
    });
  },
};
</script>
